import { useTranslations } from "next-intl";

import { useCart } from "~/hooks/use-cart";
import type { LoyaltyReward } from "~/shared/loyalty/loyalty-rewards.types";
import { getRewardMissingRequirement } from "~/shared/loyalty/loyalty-rewards.utils";
import intlUtils from "~/utils/intl-utils";

export default function useRewardRequirementHint() {
  const t = useTranslations();
  const cart = useCart();
  const priceFormatter = intlUtils.usePriceFormatter();
  const currency = cart?.ShoppingCart?.CurrencyID;

  return (reward: LoyaltyReward): string | undefined => {
    const missing = getRewardMissingRequirement(reward);
    if (!missing) {
      return undefined;
    }
    switch (missing.kind) {
      case "amount":
        return t("generic.myaccount.dashboard.rewardsMissingAmount", {
          amount: currency ? priceFormatter.currency(missing.value, { currency }) : missing.value,
        });
      case "points":
        return t("generic.myaccount.dashboard.rewardsMissingPoints", { points: missing.value });
      case "products":
        return t("generic.myaccount.dashboard.rewardsMissingProducts", { quantity: missing.value });
    }
  };
}
